const mediaItems = [
  {
    title: '直播带货翻车事件全景回顾：2026上半年行业震荡录',
    duration: '18:42',
    thumbnail: 'https://readdy.ai/api/search-image?query=Video%20production%20studio%20with%20professional%20camera%20and%20lighting%20equipment%2C%20dramatic%20interview%20setting%2C%20dark%20background%20with%20warm%20accent%20lights%2C%20documentary%20filmmaking%20aesthetic%2C%20cinematic%20mood&width=800&height=450&seq=media-01-heiliao&orientation=landscape',
    views: '128K',
    tag: '行业盘点',
  },
  {
    title: '企业数据泄露深度分析：你的个人信息还安全吗？',
    duration: '22:15',
    thumbnail: 'https://readdy.ai/api/search-image?query=Dark%20server%20room%20with%20blinking%20LED%20lights%2C%20cybersecurity%20monitoring%20screens%2C%20dramatic%20blue%20and%20red%20contrast%20lighting%2C%20tech%20investigation%20theme%2C%20cinematic%20atmosphere&width=800&height=450&seq=media-02-heiliao&orientation=landscape',
    views: '96K',
    tag: '深度分析',
  },
  {
    title: '食品安全调查实录：后厨里的秘密',
    duration: '25:30',
    thumbnail: 'https://readdy.ai/api/search-image?query=Professional%20kitchen%20with%20stainless%20steel%20surfaces%20under%20dramatic%20overhead%20lighting%2C%20food%20safety%20inspection%20theme%2C%20documentary%20style%20cinematography%2C%20warm%20and%20cold%20light%20contrast&width=800&height=450&seq=media-03-heiliao&orientation=landscape',
    views: '143K',
    tag: '调查实录',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            视频解读
          </h2>
          <p className="text-foreground-600 text-sm md:text-base">
            视频形式深度解读热门黑料事件，更直观的事件还原
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {mediaItems.map((item, idx) => (
            <div
              key={idx}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-all duration-200 cursor-pointer"
            >
              <div className="relative overflow-hidden">
                <img
                  src={item.thumbnail}
                  alt={item.title}
                  className="w-full aspect-video object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-14 h-14 flex items-center justify-center rounded-full bg-background-50/90 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-200">
                    <i className="ri-play-fill text-2xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-3 right-3 px-2.5 py-1 rounded-md bg-black/70 text-background-50 text-xs font-medium whitespace-nowrap">
                  {item.duration}
                </div>
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full bg-primary-500/90 text-background-50 text-xs font-medium whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-sm font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <div className="flex items-center gap-1 text-xs text-foreground-500">
                  <i className="ri-eye-line"></i>
                  <span>{item.views} 次播放</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}